/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

/**
 * The "staffID" parameter in the matched route is the same as the
 * authenticated user's ID.
 */
export const STAFF_ID_MATCHES_USER = 'routingStaffIdMatchesUser';
